import { useCallback } from "react";

export default function useFormDraftPersist<T extends object>(
  storageKey: string
) {
  const persist = useCallback(
    (partial: Partial<T>): void => {
      try {
        const prevRaw = sessionStorage.getItem(storageKey);
        const prev = prevRaw ? JSON.parse(prevRaw) : {};
        const next = { ...prev, ...partial };
        sessionStorage.setItem(storageKey, JSON.stringify(next));
        console.log(next);
      } catch (e) {
        console.warn("persist error", e);
      }
    },
    [storageKey]
  );

  const read = useCallback((): Partial<T> => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }, [storageKey]);

  const clear = useCallback((): void => {
    try {
      sessionStorage.removeItem(storageKey);
    } catch {}
  }, [storageKey]);

  return { persist, read, clear };
}
